<script setup lang="ts">
const props = defineProps<{
  checked: boolean
  alias: string
}>()

const { t } = useLocale()

defineEmits(['update:checked', 'update:alias'])

const checkedState = useVModel(props, 'checked')
const aliasState = useVModel(props, 'alias')
const touched = ref(false)

watch(aliasState, () => {
  if (!touched.value && aliasState.value) touched.value = true
})
const toggle = () => {
  checkedState.value = !checkedState.value
}
</script>

<template>
  <section class="my-4">
    <div class="flex flex-row items-center gap-3">
      <img
        class="cursor-pointer"
        :src="
          checkedState
            ? '/images/icons/favoriteFilled.svg'
            : '/images/icons/profileSections/favorite.svg'
        "
        @click="toggle"
      />
      <p class="text-sm">{{ t('selectRestaurant.DLV.favorite.saveTitle') }}</p>
    </div>

    <div v-if="checkedState" class="my-4 flex flex-col gap-4 md:w-1/2 md:gap-2">
      <p class="text-lg font-bold">{{ t('selectRestaurant.DLV.favorite.formTitle') }}</p>

      <div>
        <McInput
          v-model="aliasState"
          :label="t('selectRestaurant.DLV.favorite.fields.alias.label')"
          :placeholder="t('selectRestaurant.DLV.favorite.fields.alias.label')"
          name="alias"
          type="text"
        />

        <p v-if="touched && !aliasState" class="VError mt-1 text-xs text-mcd-red">
          {{ t('selectRestaurant.DLV.favorite.fields.alias.required') }}
        </p>
      </div>
    </div>
  </section>
</template>
